// The app's glyphs, inline and hand-sized. A tab bar and a few tiles are
// fifteen glyphs; a library for that ships hundreds of KB to save forty lines.

const P = { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" } as const;
const S = (d: string) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><path d={d} /></svg>
);

export const ICON = {
  // Google's mark, in its own four colours (their brand rule for a sign-in button).
  google: (
    <svg viewBox="0 0 18 18" aria-hidden="true"><path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"/><path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z"/><path fill="#FBBC05" d="M3.97 10.72A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.18.29-1.72V4.95H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.05l3.01-2.33z"/><path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"/></svg>
  ),
  home: S("M3 11l9-8 9 8v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z"),
  barns: S("M3 10l9-6 9 6v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM9 21v-7h6v7"),
  tools: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}>
      <rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  alerts: S("M18 8a6 6 0 1 0-12 0c0 7-3 8-3 8h18s-3-1-3-8M10.3 21a1.94 1.94 0 0 0 3.4 0"),
  you: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-6 8-6s8 2 8 6" /></svg>
  ),
  ticker: S("M3 17l5-6 4 4 8-9M16 6h4v4"),
  indexes: S("M4 20V11M10 20V5M16 20v-8M21 20H3"),
  // One glyph per tool in the Tools grid (owner, 2026-10-25: the grid repeated
  // the same four glyphs across thirteen tools). Same stroke, same box.
  stairs: S("M4 20h4v-4h4v-4h4V8h4"),
  steer: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><circle cx="12" cy="12" r="7" /><circle cx="12" cy="12" r="2" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" /></svg>
  ),
  medal: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><circle cx="12" cy="14" r="5" /><path d="M9.5 9.5L7 3h4l1.5 4L14 3h3l-2.5 6.5" /></svg>
  ),
  pin: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><path d="M12 21s-7-6.1-7-11a7 7 0 0 1 14 0c0 4.9-7 11-7 11z" /><circle cx="12" cy="10" r="2.5" /></svg>
  ),
  box: S("M3 8l9-4 9 4-9 4-9-4zM3 8v8l9 4 9-4V8M12 12v8"),
  dollar: S("M12 3v18M16.5 7.5c0-1.7-2-2.5-4.5-2.5S7.5 6 7.5 8s2 2.6 4.5 3.2 4.5 1.3 4.5 3.3-2 3-4.5 3-4.5-1-4.5-2.7"),
  silo: S("M6 21V8a6 6 0 0 1 12 0v13M6 21h12M6 13h12M6 17h12"),
  fuel: S("M4 21h10M5 21V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v16M5 11h8M13 9h2a2 2 0 0 1 2 2v6a1.5 1.5 0 0 0 3 0v-7l-2-2"),
  receipt: S("M6 3h12v18l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5L6 21zM9 8h6M9 12h6M9 16h4"),
  tag: S("M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9zM7.5 7.5h.01"),
  sparkles: S("M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8z"),
  report: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h3" /></svg>
  ),

  live: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><circle cx="12" cy="12" r="2.5" /><path d="M8.5 15.5a5 5 0 0 1 0-7M15.5 8.5a5 5 0 0 1 0 7M5.6 18.4a9 9 0 0 1 0-12.8M18.4 5.6a9 9 0 0 1 0 12.8" /></svg>
  ),
  map: S("M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3zM9 3v15M15 6v15"),
  board: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 10h18M9 10v10" /></svg>
  ),
  wavg: S("M12 3v18M5 7l7-4 7 4M3 13l2-6 2 6a2 2 0 0 1-4 0zM17 13l2-6 2 6a2 2 0 0 1-4 0z"),
  trophy: S("M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0zM7 6H4v2a3 3 0 0 0 3 3M17 6h3v2a3 3 0 0 1-3 3"),
  chev: S("M9 6l6 6-6 6"),
  back: S("M15 6l-6 6 6 6"),
  star: S("M12 3l3 6 6 1-4.5 4 1 6-5.5-3-5.5 3 1-6L3 10l6-1z"),
  search: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
  ),
  lock: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
  ),
  sun: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>
  ),
  moon: S("M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"),
  phone: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...P}><rect x="6" y="2" width="12" height="20" rx="2.5" /><path d="M11 18h2" /></svg>
  ),
  play: S("M6 4l14 8-14 8z"),
  share: S("M12 3v12M7 8l5-5 5 5M5 14v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5"),
} as const;
